import { render, staticRenderFns } from "./QuotationTrading.vue?vue&type=template&id=16018b73"
import script from "./QuotationTrading.vue?vue&type=script&lang=js"
export * from "./QuotationTrading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports